<template>
    <div class="spinner-border spinner-border-sm mr-1" :class="color" role="status">
        <span class="sr-only"></span>
    </div>
</template>

<script>
export default {
	name: 'SpinnerComponent',

	props: {
		color: {
			type: String,
			default: 'text-info'
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~bootstrap/scss/bootstrap';
</style>
